export const VtrListRow = function () {
  this.DATE_LAND = null;
  this.DATE_SAIL = null;
  this.DOCID = null;
  this.IS_LOCKED = null;
  this.SUBMISSION_TYPE = null;
  this.TRIP_ID = null;
  this.VESSEL_PERMIT_NUM = null;
  this.LOWEST_SERIAL_NUM = null;
};
VtrListRow.prototype.setDateLand = function (date_land) {
  this.DATE_LAND = date_land;
};
VtrListRow.prototype.setDateSail = function (date_sail) {
  this.DATE_SAIL = date_sail;
};
VtrListRow.prototype.setDocId = function (doc_id) {
  this.DOCID = doc_id;
};
VtrListRow.prototype.setIsLocked = function (locked) {
  this.IS_LOCKED = locked;
};
VtrListRow.prototype.setSubmissionType = function (submission_type) {
  this.SUBMISSION_TYPE = submission_type;
};
VtrListRow.prototype.setTripId = function (trip_id) {
  this.TRIP_ID = trip_id;
};
VtrListRow.prototype.setVesselPermitNum = function (permit) {
  this.VESSEL_PERMIT_NUM = permit;
};
VtrListRow.prototype.setLowestSerialNum = function (lowest_serial_num) {
  this.LOWEST_SERIAL_NUM = lowest_serial_num;
};
